export default {
  cardholder_name: 'Imię i nazwisko',
  cardholder_name_placeholder: 'Imię i nazwisko na karcie',
  card_number: 'Numer karty',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Data ważności',
  expiry_placeholder: 'MM / RR',
  cvv: 'Kod bezpieczeństwa',
  cvv_label: 'Kod bezpieczeństwa (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Inicjowanie bezpiecznego formularza karty…',
  sdk_load_failed: 'Nie udało się załadować bezpiecznego formularza karty. Sprawdź połączenie i odśwież stronę.',
  errors: {
    number_blank: 'Podaj numer karty.',
    number_invalid: 'Ten numer karty jest nieprawidłowy. Sprawdź cyfry i spróbuj ponownie.',
    number_incomplete: 'Numer karty jest niekompletny.',
    cvv_blank: 'Podaj kod bezpieczeństwa z tyłu karty.',
    cvv_invalid: 'Ten kod bezpieczeństwa jest nieprawidłowy. Sprawdź 3 lub 4 cyfry na karcie.',
    cvv_incomplete: 'Wprowadź wszystkie {{count}} cyfry kodu bezpieczeństwa.',
    expiry_invalid: 'Wprowadź prawidłową datę ważności w formacie MM / RR.',
    expired: 'Ta karta straciła ważność. Użyj innej karty.',
    name_blank: 'Podaj imię i nazwisko dokładnie tak, jak widnieje na karcie.',
    configuration: 'Płatności kartą są obecnie niedostępne. Wybierz inną metodę płatności.',
    generic: 'Nie udało się zweryfikować danych karty. Spróbuj ponownie.',
  },
};
